import { CSSObject } from "@emotion/react";

export const StyleSheet = <
  T extends Record<string, CSSObject | ((...args: any[]) => CSSObject)>,
>(
  styles: T,
): T => {
  return styles;
};
